import { render, staticRenderFns } from "./devicetype.vue?vue&type=template&id=506528fe&"
import script from "./devicetype.vue?vue&type=script&lang=js&"
export * from "./devicetype.vue?vue&type=script&lang=js&"
import style0 from "./devicetype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports